import { EnumQuoteServiceSalesType } from "../enum/enum-quote-service-sales-type";

export class ProductSearchRequestV2 {
    constructor(
                public countryIsoCode : string,
                public salesRole: string,
                public serviceCode?: string,
                public codeOrLabel?: string,
                public versionType?: EnumQuoteServiceSalesType,
                public extinctionIncluded?: boolean,
                public market?: string,
                public region?: string,
                public subMarket?: string,
                public clientSize?: string,
                public elisCodeList?: string[],
                ) {
    }
}
